import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import * as thunks from './thunks';

const slice = createSlice({
    name: 'subscriptions',
    initialState: {
        isLoading: false,
        status: {
            updating: false,
            loading: false,
        },
        subscriptions: [],
        subscription: null,
        errors: []
    },
    reducers: {
        setSubscriptions: (state, action) => {
            state.subscriptions = action.payload;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setSubscription: (state, action) => {
            state.subscription = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(thunks.fetchSubscriptions.pending, state => {
                state.status.loading = true;
            })
            .addCase(thunks.fetchSubscriptions.fulfilled, (state, action) => {
                state.subscriptions = action.payload;
                state.status.loading = false;
            })
            .addCase(thunks.fetchSubscriptions.rejected, (state, action) => {
                state.errors = [...state.errors, action.error];
                state.status.loading = false;
            })
            .addCase(thunks.fetchSubscription.pending, state => {
                state.status.loading = true;
            })
            .addCase(thunks.fetchSubscription.fulfilled, (state, action) => {
                state.subscription = action.payload;
                state.status.loading = false;
            })
            .addCase(thunks.fetchSubscription.rejected, (state, action) => {
                state.errors = [...state.errors, action.error];
                state.status.loading = false;
            })
            .addCase(thunks.fetchSubscriptionFromOrder.pending, state => {
                state.status.loading = true;
            })
            .addCase(thunks.fetchSubscriptionFromOrder.fulfilled, (state, action) => {
                state.subscription = action.payload;
                state.status.loading = false;
            })
            .addCase(thunks.fetchSubscriptionFromOrder.rejected, (state, action) => {
                state.errors = [...state.errors, action.error];
                state.status.loading = false;
            })
    }
});

export default slice.reducer;

export const {
    setSubscriptions,
    setSubscription,
    setLoading,
} = slice.actions;

export const {
    fetchSubscriptions,
    fetchSubscription,
    fetchSubscriptionFromOrder
} = thunks;
